import {
  faCalendarDay,
  faComments,
} from '@fortawesome/free-solid-svg-icons';
import type { ReportSection } from './types';

export const REPORT_SECTIONS = {
  DAILY_OPERATIONS: 'dailyOperations',
  CUSTOMER_FEEDBACK: 'customerFeedback',
} as const;

export type ReportSectionType = typeof REPORT_SECTIONS[keyof typeof REPORT_SECTIONS];

export const REPORT_SECTIONS_CONFIG: ReportSection[] = [
  {
    id: REPORT_SECTIONS.DAILY_OPERATIONS,
    title: 'Daily Operations',
    description: 'Detailed overview',
    icon: faCalendarDay,
    color: '#10b981',
  },
  {
    id: REPORT_SECTIONS.CUSTOMER_FEEDBACK,
    title: 'Customer Feedback',
    description: 'Detailed overview',
    icon: faComments,
    color: '#f59e0b',
  },
];

export const EMPTY_STATE_MESSAGES = {
  DAILY_OPERATIONS: 'No daily operations data available.',
  CUSTOMER_FEEDBACK: 'No customer feedback data available.',
} as const;
